var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0.194031C35.9334 0.194031 41.7336 1.9535 46.6671 5.24994C51.6006 8.54638 55.4457 13.2317 57.7164 18.7135C59.987 24.1953 60.5811 30.2273 59.4235 36.0467C58.266 41.8662 55.4088 47.2116 51.2132 51.4072C47.0176 55.6028 41.6721 58.46 35.8527 59.6176C30.0333 60.7751 24.0013 60.181 18.5195 57.9104C13.0377 55.6398 8.35235 51.7946 5.05591 46.8611C1.75947 41.9277 0 36.1275 0 30.194C0.0154533 22.2423 3.18112 14.6206 8.80386 8.99789C14.4266 3.37515 22.0482 0.209481 30 0.194031ZM20.3661 31.8956L31.9046 42.2802C32.3325 42.6651 32.8861 42.8806 33.4615 42.8863C33.782 42.8876 34.0991 42.8214 34.3922 42.6921C34.6854 42.5627 34.948 42.3731 35.1631 42.1356C35.3678 41.912 35.5265 41.6502 35.6301 41.3652C35.7336 41.0803 35.78 40.7777 35.7666 40.4748C35.7532 40.1719 35.6802 39.8747 35.5518 39.6C35.4234 39.3253 35.2422 39.0786 35.0185 38.874L25.3846 30.194L35.0185 21.511C35.4459 21.0922 35.6939 20.5237 35.7103 19.9255C35.7266 19.3274 35.5099 18.7462 35.106 18.3047C34.702 17.8633 34.1424 17.596 33.5451 17.5592C32.9478 17.5225 32.3596 17.7192 31.9046 18.1079L20.3661 28.4925C20.1302 28.7087 19.9417 28.9716 19.8128 29.2645C19.6839 29.5574 19.6174 29.874 19.6174 30.194C19.6174 30.5141 19.6839 30.8306 19.8128 31.1235C19.9417 31.4165 20.1302 31.6794 20.3661 31.8956Z",
    fill: "url(#paint0_linear_1_171)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_171",
    x1: 30,
    y1: 0.194031,
    x2: 30,
    y2: 60.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06286E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#164EC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.10ad6654e22ea3d4fd47cc03abfd78ae.svg";
export { ForwardRef as ReactComponent };